// import logo from "./logo.svg";
import "./App.scss";
import React, { useState, useRef } from "react";
// import $ from "jquery";

// import CommonUI from "./furnitures/CommonUI";

// import Heading from "./furnitures/Heading";
import Text from "./furnitures/Text";
import TopScrolly from "./furnitures/TopScrolly";
import Section from "./furnitures/Section";
import Header from "./furnitures/Header";
import Video from "./furnitures/Video";
import ScrollyVideo from "./furnitures/ScrollyVideo";
import ScrollyPhoto from "./furnitures/ScrollyPhoto";

// import ProgressBar from "react-scroll-progress-bar";
import TopImg from "./furnitures/TopImg";
import Img from "./furnitures/Img";
import Question from "./furnitures/Question";
import AllStories from "./furnitures/AllStories";
import CoverImg from "./furnitures/CoverImg";
import useResizeObserver from "./utils/useResizeObserver";

const rawData = require("./data.json");
const data = rawData.archie;
// console.log(data);

function App() {
  const widthRef = useRef(null);
  const { width, height } = useResizeObserver(widthRef);

  return (
    <>
      {/* <ProgressBar bgcolor="#000" duration="0.4" /> */}

      <div className="testing" ref={widthRef}></div>

      {data.map((d, i) => {
        // HED
        if (d.type === "header") {
          return <Header key={"header" + i} text={d.content} />;
        }
        // IMG
        else if (d.type === "img") {
          return (
            <Img
              key={"img" + i}
              imgurl={d.imgurl}
              thisClass={d.class}
              caption={d.caption}
              bg={d.bg}
            />
          );
        }
        // COVER IMG
        else if (d.type === "cover-img") {
          return (
            <CoverImg
              key={"img" + i}
              imgurl={d.imgurl}
              imgurl_m={d.imgurl_m}
              thisClass={d.class}
              caption={d.caption}
              text={d.text}
              bg={d.bg}
              width={width}
              height={height}
            />
          );
        }
        // VIDEO
        else if (d.type === "video") {
          return (
            <Video
              key={"video" + i}
              videourl={d.video}
              caption={d.caption}
              bg={d.bg}
            />
          );
        }
        // GAP
        else if (d.type === "gap") {
          return (
            <div
              key={"gap" + i}
              className="gap"
              style={{ height: width > 800 ? d.gap + "px" : d.gap_m + "px" }}
            ></div>
          );
        }
        // SECTION
        else if (d.type === "section") {
          return (
            <Section
              key={"section" + i}
              text={d.content}
              text_m={d.content_m}
              imgurl={d.img}
              icon={d.icon}
              bg={d.bg}
            />
          );
        }
        // BODY TEXT
        else if (d.type === "text") {
          return (
            <Text
              key={"text" + i}
              text={d.content}
              className={`body-text ${d.class}`}
              bg={d.bg}
            />
          );
        }
        // SCROLLY VIDEO
        else if (d.type === "scrolly-video") {
          return (
            <ScrollyVideo
              key={"scrolly-video" + i}
              steps={d.contents}
              width={width}
              height={height}
            />
          );
        }
        // SCROLLY PHOTO
        else if (d.type === "scrolly-photos") {
          return (
            <ScrollyPhoto
              key={"scrolly-photos" + i}
              steps={d.contents}
              width={width}
              height={height}
            />
          );
        }
        // TOP SCROLLY
        else if (d.type === "top-scrolly") {
          return (
            <TopScrolly
              key={"topscrolly" + i}
              videourl={d.video}
              steps={d.contents}
              width={width}
              height={height}
            />
          );
        }
        // TOP IMG
        else if (d.type === "top-img") {
          return (
            <TopImg
              key={"topimg" + i}
              imgurl={d.img}
              imgurlColor={d.img_color}
            />
          );
        }
        // QUESTION
        else if (d.type === "question-block") {
          return (
            <Question
              key={"question" + i}
              question={d.question}
              answer={d.answer}
              img={d.img}
              type={d.class}
            />
          );
        }
        // All Stories
        else if (d.type === "all-stories") {
          return <AllStories key={"story" + i} stories={d.contents} />;
        }
      })}
    </>
  );
}

export default App;
